<template>
  <div v-if="modalBuiltIn" :class="$props.class">
    <!-- title -->
    <div class="bg-white p-4 mr-32">
      <div class="flex items-center justify-start">
        <div
          class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
          <ExclamationTriangleIcon class="h-6 w-6 text-red-600" aria-hidden="true" />
        </div>
        <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
          <h3 class="text-lg leading-6 font-medium text-gray-900">
            {{ modalBuiltIn.title }}
          </h3>
        </div>
      </div>
    </div>
    <!-- content -->
    <div class="px-6 pb-4">
      <slot name="content">
        <div class="mt-2 text-justify">
          <p v-for="desc in modalBuiltIn.content" class="text-sm text-gray-500">
            {{ desc }}&nbsp;
          </p>
        </div>
      </slot>
    </div>
    <!-- footer buttons -->
    <div class="px-6 py-2 bg-gray-50 flex flex-row-reverse gap-x-2">
      <slot name="buttons" :close="close">
        <button v-for="button in modalBuiltIn.buttons" @click="close(button.value)" :class="['button', button.class]">
          {{ button.title }}
        </button>
      </slot>
    </div>
  </div>
  <!-- :class="$props.fullscreen ? 'min-w-[90vw] min-h-[90vh]' : 'min-w-[70vw] min-h-[70vh]'" -->
  <div v-if="modalComponent" :class="$props.class">
    <component :is="modalComponent.component" v-bind="modalComponent.componentProps" />
  </div>
</template>

<script lang="ts">
import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline'

type ButtonClass = 'button-default' | 'button-red'

export type ModalBuitIn = {

  preset?: 'dialog' | 'contactsearch'

  title: string;

  /** paragraph content or use: <template v-slot:content> */
  content?: string[];

  /** buttons with return value or use: <template v-slot:buttons="{ close }"> */
  buttons?: {
    title: string;
    value: any;
    class?: ButtonClass | string;
  }[];


  gButtonFullscreen?: true
  gButtonClose?: false
  component?: never
  componentProps?: never
}

export type ModalComponent = { component: any; componentProps?: any; gButtonFullscreen?: true; gButtonClose?: false }

export type ModalOpt = ModalBuitIn | ModalComponent

export default {
  components: {
    ExclamationTriangleIcon
  },
  props: {
    opt: Object as PropType<ModalOpt>,
    class: String
  },
  emits: ['close', 'hide'],
  setup(props, { emit }) {

    const { $rootEmitter } = useNuxtApp()

    const modalBuiltIn = computed<ModalBuitIn>(() => {
      if (!props.opt || props.opt.component) return;
      const o = props.opt as ModalBuitIn;
      return {
        preset: o.preset || 'dialog',
        title: o.title,
        content: o.content,
        buttons: o.buttons || [
          { title: 'Ok', value: true, class: 'button-red py-1 px-2 ml-2' },
          { title: 'Annuler', value: false, class: 'button-default py-1 px-2' }
        ]
      }
    })

    const modalComponent = props.opt.component ? props.opt as ModalComponent : undefined

    return {
      modalBuiltIn,
      modalComponent,

      close(val?: any) {
        emit('close', val)
        $rootEmitter.emit('modal-close', val)
      }
    };
  }
};
</script>